const Header = () => (
  <div class='header'>
    <div class='header-content'>
      <div class='brand'>
        <span class='brand-icon'>📦</span>
        <span class='brand-name'>Movaex Logistics</span>
      </div>
      <div class='header-title'>
        <span class='header-icon'>📱</span>
        <h1 className="header_h1">iPhone 17 Pre-Order</h1>
      </div>
    </div>
  </div>
);

export default Header;
